module.exports = __webpack_public_path__ + "static/media/notes-of-love-one.9591c553.png";